import { render } from "./NotificationsColumn.vue?vue&type=template&id=2316010c&ts=true"
import script from "./NotificationsColumn.vue?vue&type=script&lang=ts"
export * from "./NotificationsColumn.vue?vue&type=script&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./NotificationsColumn.vue?vue&type=style&index=1&id=2316010c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__